export default {

  // Months
  jan: "Jan",
  feb: "Feb",
  mar: "Mar",
  apr: "Apr",
  may: "May",
  jun: "Jun",
  jul: "Jul",
  aug: "Aug",
  sep: "Sep",
  oct: "Oct",
  nov: "Nov",
  dec: "Dec",

 
  // Request Payment
  requestPaymentDetails: "Payment Details",
  selected: "Selected",

  // PaymentGateWay-CyberSource
  accessKey: "Access Key",
  profileId: "Profile ID",
  locale: "Locale",
  csUrl: "Cyber Source URL",
  secretKey: "Secret Key",
  csReviewUrl: "Review URL",
  csResultUrl: "Result URL",
  merchantId: "Merchant ID",
  merchantName: "Merchant Name",
  

  // Others
  thisPage: "This Page",
  purchase: "Purchase",
  ar: "Arabic",
  en: "English",
  KD: "KD",
  is: "is",
  search: "Search",
  ellipses: "...",
  OK: "OK",
  cancel: "Cancel",
  save: "Save",
  title: "Title",
  clear: "Clear",
  prev: "Prev",
  next: "Next",
  confirm: "Confirm",
  qmark: "?",
  digits: "digits.",
  copy: "Copy",
  choose: "Choose",
  file: "File",
  confirmLogout: "Are you sure you want to logout",
  copyright:
    "2020 Future Communication Company Pvt. Ltd., All Rights Reserved.",
  hintResponseURL: "https://payme.fcc-kuwait.com/knet/response",
  hintErrorURL: "https://payme.fcc-kuwait.com/knet/error",

  // Errors
  inActiveUser: " You are not a active user! Please contact system admin.",
  pleaseEnterValidAmount: "Please enter valid amount.",
  dataIsNotAvailable: "Data is not available.",
  internalError: "Sorry, an error has been occurred.",
  sessionExpired: "Your session has expired. Please login.",
  networkError: "Unable to connect to server. Please try again.",
  notAuthorized:
    "You are not authorized to perform action. Please contact administrator.",
  invalidUsernameOrPassword: "Invalid username or password.",
  tenantAlreadyExist: "Tenant already exist.",
  customerAlreadyExist: "Customer already exist",
  pleaseFilledRequiredFields: "Please fill required fields.",
  pleaseFillAllRequiredFields: "Please fill all required fields.",
  unMatchedNewAndConfirmPassword:
    "New password does not match with confirm password.",
  unMatchedPasswordAndConfirmPassword:
    "Password does not match with confirm password.",
  somethingWentWrong: "Something went wrong.",
  pleaseSelectCustomer: "Please select customer.",
  notAvailable: "N/A",
  maximumRetryAttemptReached:
    "Maximum attempts reached. Please make a new request.",
  tokenExpiredMakeNewRequest: "Token is expired. Please make a new request.",
  tokenAlreadyProcessed: "Transaction has been already processed.",
  tokenNotFound: "Token not found.",
  knetInitFailed: "Payment initialisations has failed.",
  invalidMobileNumber: "Invalid mobile number.",
  invalidMobileNumberLength: "Mobile number should be",
  weakPassword:
    "Password must start with alphabet and also must contain atleast one capital,one digit,and one special character and of length 8-12",
  invalidCurrentPassword: "Invalid current password.",
  matchedNewAndCurrentPassword: "New password is same as current password.",
  noNetworkConnection: "No network connection.",
  invalidErrorUrl: "Invalid error URL.",
  invalidResponseUrl: "Invalid response URL.",
  minMobileNumberLength: "Mobile number should be minimum ",
  adminUserAlreadyExist: "User with given Email ID is already exists.",
  pleaseCreateRolesFirst: "Please add Roles first",
  roleAlreadyExists: "Role with given name already exists.",
  roleNotFound: "Role Not Found",
  roleIsAssignedToUser:
    "Role can not be deactivated as it is assigned to at least one user.",
  invalidConfiguration: "Invalid configuration",
  groupAlreadyExists: "Group with given name already exists",
  paymentGatewayNotConfigured:
    "There is no Payment Gateway configured. You cannot initiate Payment Request.",

  // payment screens
  paymentText: "How do you want to pay?",
  reference: "Reference",
  track: "Track",
  knetTrack: "KNET Track",
  paymentTrack: "Payment Track",
  id: "ID",
  pay: "Pay Now",
  paymentError: "Payment Error",
  paymentFailed: "Payment Failed",
  merchantConfirmSmt: "is requesting payment from you.",
  paymentConfirmSmt: "Please confirm below details to proceed with payment.",
  KnetRefID: "Knet Ref",
  KnetTransID: "Knet Trans",
  KnetPaymentID: "Knet Payment",
  MReferenceID: "Reference",
  FPayTrackID: "Track",
  MigsTransactionNo: "CC Transaction",
  MigsReceiptNo: "CC Receipt",
  clickHere: "click here.",
  clickHereText: "If you are not redirected in few seconds, ",
  thank_you: "Thank You!",
  thank_you_desc: "Your payment is completed Successfully",
  SelectMethod: "Select Payment Method",
  OrderSummary: "Order Summary",
  KNET: "KNET",
  KNETSubTitle: "Redirect to Knet payment page.",
  CreditCard: "Credit Card",
  CreditCardSubTitle: "We accept Visa, Master card.",
  TotalPrice: "Total Price",
  oops: "Oops!!",
  payment_fail_lbl: "Your payment failed",
  payment_fail_desc: "Please try again",
  error_msg: "We are sorry, something went wrong.",
  unknown_payment:"Unknown Payment"
};



// WEBPACK FOOTER //
// ./src/resources/i18n/en.js